import Cookies from 'js-cookie';
import { toast } from 'react-toastify';

/**
 * Limpia la sesión del usuario eliminando las cookies y redirige a la página de inicio.
 * @param {string} errorMsg - Mensaje de error opcional para mostrar luego del cierre de sesión.
 */
export const clearSession = (errorMsg) => {
  if (errorMsg) {
    Cookies.set('logoutError', errorMsg);
  }
  Cookies.remove('auth');
  localStorage.removeItem('token');
  window.location.href = '/';
};

/**
 * Muestra un toast si ocurrió un error al cerrar la sesión.
 */
export const showLogoutError = () => {
  const errorMsg = Cookies.get('logoutError');
  if (errorMsg) {
    toast.error(errorMsg);
    Cookies.remove('logoutError');
  }
};
